import { useInitialState } from './useInitialState';
import { useSiteId } from './useSiteId';
import { useFavoritesContext } from '../context/Favorites';

const logToDataLayer = (checked, origoData) => {
  const { hotelCode, transport, priceOffer } = origoData || {};
  const { destinationCode, departureCode } = transport || {};
  const discount =
    priceOffer?.ordinaryPrice && priceOffer?.totalPrice
      ? priceOffer.ordinaryPrice - priceOffer.totalPrice
      : undefined;

  const data = {
    event: checked ? 'add_favorite_hotel' : 'remove_favorite_hotel',
    'gtm.uniqueEventId': checked ? 167 : 414,
    hotelWVId: Number(origoData?.content?.wvId) || undefined,
    travelHotelCode: hotelCode,
    travelDestinationCode: destinationCode,
    travelDepartureCode: departureCode,
    travelProductBrand: origoData?.content?.productInfo?.productName || undefined,
    travelHasDiscount: discount > 0,
    travelDiscountAmount: discount,
    travelPromotionLabel: origoData?.promotionLabels?.[0]?.text,
  };

  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push(data);
  }
};

export const useFavorites = (origoData) => {
  const { idunUrl } = useInitialState();
  const siteId = useSiteId();
  const wvId = origoData?.content?.wvId;
  const { favoriteIds, isLoading, setFavorite } = useFavoritesContext();
  const isFavorite = favoriteIds.includes(wvId);

  const onChangeFavorite = (e) => {
    const { checked } = e.target;
    const action = checked ? 'add' : 'delete';

    logToDataLayer(checked, origoData);

    setFavorite(wvId, checked);

    fetch(`${idunUrl}/api/favorites/${action}/${wvId}?siteId=${siteId}`, {
      credentials: 'include',
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to ${action} favorite`);
        }
      })
      .catch(() => {
        setFavorite(wvId, !checked);
      });
  };

  return { isFavorite, onChangeFavorite: isLoading ? undefined : onChangeFavorite };
};
